import Basketball from '@/assets/graphical-elements/basketball.svg'
import {cn} from '@/lib/utils'
import {type IconProps} from '../types'

export const BasketballIcon = ({className}: IconProps) => <Basketball className={cn('fill-current', className)} />
